type Tone = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

const toneClasses: Record<Tone, string> = {
  success: 'bg-zt-primary/10 text-zt-primary',
  warning: 'bg-zt-warning/10 text-zt-warning',
  danger: 'bg-zt-danger/10 text-zt-danger',
  info: 'bg-zt-info/10 text-zt-info',
  neutral: 'bg-zt-elevated text-zt-muted',
};

const POSITIVE = ['ok', 'healthy', 'active', 'completed', 'success', 'settled', 'paid', 'posted', 'verified', 'processed', 'sent', 'reconciled', 'matched', 'transmitted', 'approved', 'connected'];
const WARN = ['warn', 'pending', 'processing', 'stale', 'draft', 'unclaimed', 'on_hold', 'degraded', 'received', 'unpaid'];
const NEGATIVE = ['error', 'failed', 'failing', 'denied', 'reversed', 'dead_letter', 'rejected', 'expired', 'flagged', 'not_configured', 'disconnected'];

function toneForStatus(status: string | null | undefined): Tone {
  const s = (status ?? '').toLowerCase();
  if (POSITIVE.includes(s)) return 'success';
  if (WARN.includes(s)) return 'warning';
  if (NEGATIVE.includes(s)) return 'danger';
  return 'neutral';
}

interface StatusPillProps {
  status: string | null | undefined;
  tone?: Tone;
  label?: string;
}

function StatusPill({ status, tone, label }: StatusPillProps) {
  const resolvedTone = tone ?? toneForStatus(status);
  const text = label ?? (status ? status.replace(/[_-]+/g, ' ') : 'unknown');
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium capitalize ${toneClasses[resolvedTone]}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {text}
    </span>
  );
}

export default StatusPill;
